export { default } from './CompanyLogos';
